import { render } from "./ProductCatalogOutlet.vue?vue&type=template&id=3c4e4e94&ts=true&lang=pug"
import script from "./ProductCatalogOutlet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCatalogOutlet.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__